import React from 'react'
import {
  StaticRouter,
} from 'react-router-dom'

import {
  createAppShell,
  createPageElements,
  createMatchPage,
} from './multiPageAdapters'

/* --------------------------------------- */

const createRouter = options => props => {
  const { location, context, pageInfo, shellPropsFromServer } = props

  if (!location) {
    throw new Error(`[FunkGoRouter] invalid parameters`)
  }

  // for SSR, pass page info to each page via static router context
  const routerContext = {
    ...context,
    ...pageInfo,
    shellPropsFromServer,
    pluginHub: options.pluginHub
  }

  return (
    <StaticRouter location={location} context={routerContext}>
      {props.children}
    </StaticRouter>
  )
}

/* --------------------------------------- */

export {
  createAppShell,
  createRouter,
  createPageElements,
  createMatchPage,
}